const PLACEMENT_CLASSES = {
    LOADED: 'promo-placement--loaded',
    STUB: 'promo-placement--stub',
    ERROR: 'promo-placement--error',
    VISIBLE: 'is-visible'
};

const STATE_CLASSES = {
    loaded: [PLACEMENT_CLASSES.LOADED, PLACEMENT_CLASSES.VISIBLE],
    stub: [PLACEMENT_CLASSES.STUB],
    error: [PLACEMENT_CLASSES.ERROR]
};

const ALL_PLACEMENT_CLASSES = Object.values(PLACEMENT_CLASSES);

function createAdFoxContainerManager() {
    const activeContainers = new Set();
    const containerStates = new Map();

    function getContainer(containerId) {
        return document.querySelector(`#${containerId}`);
    }

    function getContainerWidth(container) {
        return container.offsetWidth
            || (container.parentElement ? container.parentElement.clientWidth : 0)
            || window.innerWidth;
    }

    function hideContainer(container) {
        const { style } = container;
        style.visibility = 'hidden';
        style.display = 'block';
        style.position = 'absolute';
        style.left = '-9999px';
    }

    function resetStyles(container) {
        const { style } = container;
        style.visibility = 'visible';
        style.position = '';
        style.left = '';
        style.width = '';
    }

    function applyState(containerId, state, isAlwaysStub) {
        const container = getContainer(containerId);
        if (!container) return;

        resetStyles(container);
        container.classList.remove(...ALL_PLACEMENT_CLASSES);

        if (STATE_CLASSES[state]) {
            container.classList.add(...STATE_CLASSES[state]);
        }

        if (isAlwaysStub || state === 'loaded') {
            container.classList.add(PLACEMENT_CLASSES.VISIBLE);
            container.style.display = 'block';
        } else {
            container.style.display = 'none';
        }

        if (state === 'loaded') {
            activeContainers.add(containerId);
        }

        containerStates.set(containerId, state);
    }

    function prepareForRecreate(containerId) {
        const container = getContainer(containerId);
        if (container) {
            container.innerHTML = '';
            container.classList.remove(...ALL_PLACEMENT_CLASSES);
        }
        containerStates.delete(containerId);
    }

    function clearContainer(containerId, keepState = false) {
        const container = getContainer(containerId);
        if (container) {
            container.innerHTML = '';
            const { style } = container;
            style.display = 'none';
            style.visibility = '';
            style.position = '';
            style.left = '';
            style.width = '';
            container.classList.remove(...ALL_PLACEMENT_CLASSES);
        }
        activeContainers.delete(containerId);
        if (!keepState) {
            containerStates.delete(containerId);
        }
    }

    return {
        get activeContainers() { return activeContainers; },
        get containerStates() { return containerStates; },
        getContainer,
        getContainerWidth,
        hideContainer,
        applyState,
        prepareForRecreate,
        clearContainer
    };
}

export { PLACEMENT_CLASSES, ALL_PLACEMENT_CLASSES };
export default createAdFoxContainerManager;
